import React from 'react';
import { AppProvider } from '@crm/contexts/AppContext';
import AppErrorBoundary from '@crm/components/AppErrorBoundary';
import NotificationManager from '@crm/components/NotificationManager';
import ProtectedRoute from './ProtectedRoute';
import CCCMainLayout from '../layout/CCCMainLayout';
import { CccNotificationsProvider } from '../hooks/useCccNotifications';

/** Authenticated CCC routes — AppProvider + layout (skipped on /login). */
const CccAuthenticatedShell: React.FC = () => (
  <AppErrorBoundary scope="App">
    <AppProvider>
      <ProtectedRoute>
        <CccNotificationsProvider>
          <NotificationManager>
            <CCCMainLayout />
          </NotificationManager>
        </CccNotificationsProvider>
      </ProtectedRoute>
    </AppProvider>
  </AppErrorBoundary>
);

export default CccAuthenticatedShell;
